var map = {
	"./all.png": "fef1",
	"./angelic.png": "291a",
	"./barbarian.png": "3d90",
	"./coffin1.png": "5876",
	"./cross.png": "fcfb",
	"./deathknight.png": "8c63",
	"./demon.png": "33ad",
	"./derathian.png": "b7fd",
	"./derathian_old.png": "9202",
	"./dragon.png": "01d6",
	"./dragon_rune.png": "ea1e",
	"./elemental.png": "578d",
	"./evolution.png": "8e75",
	"./fighter.png": "3b5e",
	"./fury.png": "ab5a",
	"./hell.png": "2d4d",
	"./lycan.png": "6c12",
	"./music.png": "5952",
	"./mutation.png": "d64e",
	"./nature.png": "7672",
	"./penta.png": "4744",
	"./priest.png": "81a1",
	"./ranger.png": "deef",
	"./ranger_old.png": "de5b",
	"./shaman.png": "f7e3",
	"./shield.png": "63c5",
	"./sorcerer.png": "25ebf",
	"./spell.png": "9aab",
	"./spiritual.png": "9b0d",
	"./summoner.png": "132c",
	"./vampire.png": "7010",
	"./wizard.png": "6020"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb92";